import React from 'react';

export const RaIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 1247 598"
        width="1em"
        height="1em"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="matrix(1.3333333,0,0,-1.3333333,0,597.93333)">
            <g transform="scale(0.1)">
                <path d="m 9250.08,894.852 c 62.74,59.75 102.36,143.478 102.36,236.928 0,89.94 -42.8,170.78 -101.41,229.97 L 6610.4,4002.38 5813.38,3205.36 7892.39,1126.35 H 4946.88 c -143.99,4.31 -258.1,52.62 -354.65,146.19 L 3270.56,2594.21 c -137.05,129.6 -324.79,211.6 -528.34,211.6 -0.72,0 -1.39,-0.1 -2.01,-0.1 v 0.1 H 1127.2 v 551.52 h 1670.56 v -0.11 c 330.99,-0.16 626.31,-135.63 842.78,-353.03 l 985.84,-985.83 797.02,797.02 -1005,1005 c -420.08,413.68 -987.4,664.11 -1623.49,664.11 -0.67,0 -1.38,-0.04 -2.06,-0.04 v 0.04 H 0 V 1678.66 h 2363.79 v -0.18 c 153.74,-1.1 292.54,-64.33 392.76,-165.88 L 4050.96,218.152 C 4182.62,88.8516 4360.51,7.33984 4557.76,0 h 3575.7 c 150.53,1.98047 286.48,63.6094 385.7,162.539 l 731.47,731.402 -0.55,0.911" />
            </g>
        </g>
    </svg>
);
